<template>
    <Top />
    <!-- Spinner Start -->
    <div id="spinner" v-if="halamanloading"
        class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
        <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        &nbsp;<img src="../../../../src/assets/img/BerandaNgumahLogo.png" height="40">
        &nbsp;<span class="text-danger">..Loading...</span>
    </div>
    <!-- Spinner End -->
    <!-- Header Start -->
    <div class="modal fade" id="costumModaldisclaimer" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
        aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
        style="background: rgba(240, 248, 255, 0.1);">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Penjelasan dan Ketentuan</h4>
                </div>
                <div class="modal-body text-justify">
                    <p style="font-size: smaller;">
                        <b>SIMFAST JATENG</b> (Sistem Manajemen Infrastruktur Terpadu Jawa Tengah)
                        yang selanjutnya dioptimalkan sebagai "<b>Strategi Mensinergikan Fokus dan Arah Kebijakan
                        Perencanaan Berbasis Data Spasial Terpadu di Jawa Tengah</b>" merupakan sistem manajemen (alat
                        kerja) yang mengintegrasikan analisa data dan informasi infrastruktur (terkait Urusan PUPR,
                        Perhubungan, Prakim, LHK, ESDM, Kominfo) secara terpadu dengan sektor lain (ekonomi dan sosial)
                        untuk menghasilkan prioritas rencana penanganan infrastruktur di Jawa Tengah yang paling efektif
                        dan efisien dalam mewujudkan tujuan pembangunan di Provinsi Jawa Tengah.
                    </p>
                    <p class="text-center">
                    <div class="row">
                        <div class="col-sm-12 float-left">
                            <label style="font-size: smaller;" class="text-success">Silahkan Mengisi Daftar
                                Pengunjung</label>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-address-card"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="nama" name="nama"
                                    placeholder="Nama" v-model="nama">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-phone-square"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="hp" name="hp"
                                    placeholder="Nomor Telepon" v-model="hp" @keypress="onlyNumberKey(event)"
                                    @keydown="onlyNumberKey(event)">
                            </div>
                        </div>
                        <div class="col-sm-12 float-left">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-clipboard-list"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="keperluan" name="keperluan"
                                    placeholder="Keperluan" v-model="keperluan">
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capcha" name="capcha"
                                    placeholder="Kode Keamanan" v-model="capcha" disabled @click.right.prevent
                                    @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                        <div class="col-sm-6 float-left">
                            <label style="font-size: smaller;" class="text-success">Ulangi Kode Keamanan</label>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><i class="far fa-clone"></i></span>
                                </div>
                                <input type="text" class="form-control form-control-sm" id="capchainput"
                                    name="capchainput" v-model="capchainput" style="text-transform:uppercase"
                                    @click.right.prevent @keydown="keydown" @copy.prevent @paste.prevent>
                            </div>
                        </div>
                    </div>
                    <input type="checkbox" id="customSwitchAuth" @click="rubahisi()">
                    <label style="font-size: small;" for="customSwitchAuth">
                        &nbsp;Saya mengerti dan menyetujui penjelasan dan ketentuan diatas.
                    </label>
                    </p>
                </div>
                <div class="modal-footer justify-content-between">
                    <button class="btn btn-danger2 btn-block text-white" placeholder="Setuju dan lanjutkan"
                        data-toggle="tooltip" data-placement="left" title="Setuju dan lanjutkan.." style="color: black;"
                        :disabled="showHuman == false" @click="setuju()">
                        <b>
                            Setuju dan lanjutkan
                        </b>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid bg-breadcrumb">
        <div class="container text-center py-5" style="max-width: 900px;">
            <h3 class="text-white display-3 mb-4 wow fadeInUp pmisputih" data-wow-delay="0.1s">
                <span v-if="(bahasa === null) || (bahasa == 'ina')">BANK DOKUMEN INFRASTRUKTUR</span>
                <span v-else>BANK DOKUMEN INFRASTRUKTUR</span>
            </h3>
            <ol class="breadcrumb justify-content-center mb-0 wow fadeInUp" data-wow-delay="0.3s">
                <li class="breadcrumb-item">
                    <a href="/">
                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Beranda</span>
                        <span v-else>Home</span>
                    </a>
                </li>
                <li class="breadcrumb-item active text-primary">
                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Dokumen Infrastruktur Publik Provinsi Jawa
                        Tengah</span>
                    <span v-else>Dokumen Infrastruktur Publik Provinsi Jawa
                        Tengah</span>
                </li>
            </ol>
        </div>
    </div>
    <!-- Header End -->
    <div class="container-fluid py-4 wow fadeInUp" data-wow-delay="0.1s">
        <div class="section-title mb-5 wow fadeInUp" data-wow-delay="0.1s"
            style="visibility: visible; animation-delay: 0.1s; animation-name: fadeInUp;">
            <div class="sub-style">
                <h4 class="sub-title px-3 mb-0 labelpmis">
                    BANK DOKUMEN INFRASTRUKTUR JAWA TENGAH
                </h4>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-sm-1 wow fadeInUp"></div>
                <div class="col-sm-10 wow fadeInUp">
                    <div class="col-sm-12 float-left pb-2">
                        <div class="input-group mb-3">
                            <input id="carikata" v-model="carikata" placeholder="Masukkan Kata Kunci Pencarian Dokumen"
                                type="text" class="form-control form-control-sm" style="font-size: small !important;" @change="ambildata()">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="ambildata()" style="cursor: pointer;"><i
                                        class="fas fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                    <ul id="tree1" style="cursor: pointer;">
                    </ul>
                </div>
                <div class="col-sm-1 wow fadeInUp"></div>
            </div>
        </div>
    </div>
    <a href="#" class="btn btn-dangerbulet btn-lg-square back-to-top text-white"><i class="fa fa-arrow-up"></i></a>
    <Footer />
</template>

<script>
import { ref } from 'vue'
import treeview from "vue3-treeview";
import "vue3-treeview/dist/style.css";
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import xlsx from 'xlsx/dist/xlsx.full.min';
import Top from "./Template/Top.vue";
import Footer from "./Template/Footer.vue";
import vSelect from 'vue-select';
import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-Regular, Arial, sans-serif" };

export default {
    components: {
        Top, Footer, swal, tree: treeview, vSelect
    },
    data() {
        return {
            halamanloading: true,
            showHuman: false,
            tampilmodal: localStorage.getItem("bookstamu"),
            capcha: this.makeid(5), capchainput: "",
            nama: '',
            hp: '',
            keperluan: '',
            ipnya: '',
            datapesan: '',
            datamaster: [],
            carikata: '',
        };
    },
    methods: {
        onlyNumberKey(evt) {
            // Only ASCII character in that range allowed
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();;
            } else {
                return true;
            } return;
        },
        rubahisi() {
            if ((this.showHuman == false) && (this.capcha == this.capchainput.toUpperCase())) {
                if (this.nama.length <= 2) {
                    this.showHuman = false;
                    document.getElementById("customSwitchAuth").checked = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nama dengan benar',
                    });
                    return false;
                }
                if ((this.hp.length <= 4) || (typeof parseInt(this.hp) != "number")) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan nomor telp dengan benar',
                    });
                    return false;
                }
                if (this.keperluan.length <= 3) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Isikan keperluan dengan benar',
                    });
                    return false;
                }
                this.showHuman = true;
            }
            else {
                if (this.capcha != this.capchainput.toUpperCase()) {
                    document.getElementById("customSwitchAuth").checked = false;
                    this.showHuman = false;
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: 'Kode keamanan tidak sama',
                    });
                }
                this.showHuman = false;
            }
        },
        async setuju() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            this.halamanloading = true;
            const data = {
                tamuparastapa: 'tamuparastapa',
                nama: this.nama,
                hp: this.hp,
                keperluan: this.keperluan,
            };
            const mainAPIVisitor = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            await mainAPIVisitor.post("parastapainnovatioBukuTamu-IsiTamu", data).then(
                Response => {
                    if (Response.data.response == 'error') {
                        swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000
                        }).fire({
                            icon: 'warning',
                            title: Response.data.message,
                        });
                        this.halamanloading = false;
                        return false;
                    }
                    else {
                        localStorage.setItem("bookstamu", new Date().toString());
                        $('#costumModaldisclaimer').modal('hide');
                        this.halamanloading = false;
                        //window.location.reload();
                    }
                }
            ).catch(
                error => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: error,
                    });
                }
            )

        },
        async cekdisklaimer() {
            if ((this.tampilmodal == null) || (this.tampilmodal == '') || (this.tampilmodal == undefined)) {
                $('#costumModaldisclaimer').modal('show');
            }

            var time = Date.parse(localStorage.getItem("bookstamu"));
            var timeakhir = time + (1 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                $('#costumModaldisclaimer').modal('show');
            }
        },
        InisialisasiTree() {
            $.fn.extend({
                treed: function (o) {

                    var openedClass = 'fas fa-minus';
                    var closedClass = 'fas fa-plus';

                    if (typeof o != 'undefined') {
                        if (typeof o.openedClass != 'undefined') {
                            openedClass = o.openedClass;
                        }
                        if (typeof o.closedClass != 'undefined') {
                            closedClass = o.closedClass;
                        }
                    };

                    //initialize each of the top levels
                    var tree = $(this);
                    tree.addClass("tree");
                    tree.find('li').has("ul").each(function () {
                        var branch = $(this); //li with children ul
                        branch.prepend("<i class='indicator glyphicon " + closedClass + "'></i>");
                        branch.addClass('branch');
                        branch.on('click', function (e) {
                            if (this == e.target) {
                                var icon = $(this).children('i:first');
                                icon.toggleClass(openedClass + " " + closedClass);
                                $(this).children().children().toggle();
                            }
                        })
                        branch.children().children().toggle();
                    });
                    //fire event from the dynamically added icon
                    tree.find('.branch .indicator').each(function () {
                        $(this).on('click', function () {
                            $(this).closest('li').click();
                        });
                    });
                    //fire event to open branch if the li contains an anchor instead of text
                    tree.find('.branch>a').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                    //fire event to open branch if the li contains a button instead of text
                    tree.find('.branch>button').each(function () {
                        $(this).on('click', function (e) {
                            $(this).closest('li').click();
                            e.preventDefault();
                        });
                    });
                }
            });
            //Initialization of treeviews
            $('#tree1').treed();
            $('#treelegenda').treed();
            $('.select2').select2();

            //Initialize Select2 Elements
            $('.select2bs4').select2({
                theme: 'bootstrap4'
            });
        },
        async ambildata() {
            this.halamanloading = true;

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();

            await mainAPI.get("parastapainnovationip-Key?random=" + random).then(
                Response => {
                    this.datapesan = Response.data.message;
                    if (this.datapesan == 'data diketemukan') {
                        this.ipnya = Response.data.randkey;
                    }
                    else {
                        this.ipnya = '';
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });

            const mainAPI2 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2" + this.ipnya,
                },
            });
            var random = Math.random();
            await mainAPI2.get("parastapainnovationdokumen-GetDokumen?random=" + random + "&nama=" + this.carikata).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        document.getElementById("tree1").innerHTML = '';
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        for (var i = 0; i < this.datamaster.length; i++) {
                            if (this.datamaster[i].id_parent == null) {

                                var node = document.createElement("li");
                                node.setAttribute("id", this.datamaster[i].id);
                                var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");

                                if (this.datamaster[i].namajenismenu != 'Folder') {
                                    var link = document.createElement("a");
                                    var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                    link.id = 'link_' + this.datamaster[i].id;

                                    if (this.datamaster[i].namajenismenu != 'Tautan') {
                                        link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                        link.title = this.datamaster[i].filenya_dokumen;
                                    }
                                    else {
                                        link.title = this.datamaster[i].tautan;
                                        link.href = this.datamaster[i].tautan;
                                        link.setAttribute("target", "_blank");
                                    }
                                    link.appendChild(textlink);
                                    node.appendChild(link);
                                }
                                else {
                                    node.appendChild(textnode);
                                }

                                document.getElementById("tree1").appendChild(node);
                            }
                            else {

                                var node = document.createElement("li");
                                node.setAttribute("id", this.datamaster[i].id);
                                var textnode = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                if (this.datamaster[i].namajenismenu != 'Folder') {
                                    var link = document.createElement("a");
                                    var textlink = document.createTextNode(" " + this.datamaster[i].nama + " ");
                                    link.id = 'link_' + this.datamaster[i].id;

                                    if (this.datamaster[i].namajenismenu != 'Tautan') {
                                        link.href = this.folder_foto + this.datamaster[i].filenya_dokumen;
                                        link.title = this.datamaster[i].filenya_dokumen;
                                    }
                                    else {
                                        link.title = this.datamaster[i].tautan;
                                        link.href = this.datamaster[i].tautan;
                                        link.setAttribute("target", "_blank");
                                    }
                                    link.appendChild(textlink);
                                    node.appendChild(link);
                                }
                                else {
                                    node.appendChild(textnode);
                                }

                                var ul = document.createElement("ul");
                                ul.setAttribute("id", "ul" + this.datamaster[i].id);
                                ul.appendChild(node);
                                document.getElementById(this.datamaster[i].id_parent).appendChild(ul);
                            }
                        }
                        $('#tree1').treed();
                    }
                    else {
                        this.datamaster = [];
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = '';
                this.datamaster = [];
                //console.log(error);
                this.halamanloading = false;
            });

        },
    },
    mounted() {
        this.ambildata();
        this.InisialisasiTree();
        this.cekdisklaimer();
        window.addEventListener('keydown', function (event) {
            if (event.code == 'KeyZ' && (event.ctrlKey || event.metaKey)) {
                localStorage.setItem("bookstamu", new Date().toString());
                $('#costumModaldisclaimer').modal('hide');
            }
        });
    },
}
</script>

<style></style>